export const GET_SDK_LIST = 'GET_SDK_LIST';//get sdk platForm list
export const ADD_SDK_SERVICE = 'ADD_SDK_SERVICE';//add sdk service
export const EDIT_SDK_SERVICE = 'EDIT_SDK_SERVICE';//edit sdk service
export const DELETE_SDK_SERVICE = 'DELETE_SDK_SERVICE';//delete sdk service
